<template>
    <div class="pageBox">
        <div class="pageFrame">
            <el-tabs v-model="activeName" tab-position="left" class="content">
                <el-tab-pane label="检测标准" name="first">
                    <div class="haveData" v-if="standard.length>0">
                        <el-tabs type="card" v-model="activeName_standard">
                            <el-tab-pane label="检测标准" name="standard">
                                <div class="item_scan" v-for="(item,index) in standard" :key="index">
                                    <div class="name">{{ item.name }}</div>
                                    <div class="scan" @click="fileLinkToStreamDownload(item.fileUrl,item.name)">
                                        点击下载
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                        <div class="pagination">
                            <el-pagination
                                @current-change="handleCurrentChange"
                                :current-page="pageIndex"
                                :page-size="pageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="totalCount">
                            </el-pagination>
                        </div>
                    </div>
                    <div class="noData" v-else>暂无数据！</div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>

export default {
    name: "testStandard",
    data() {
        return {
            activeName: 'first',
            activeName_standard: 'standard',
            standard: [],
            totalCount: 15,
            pageSize: 10,
            pageIndex: 1,
            wait: true
        }
    },
    mounted() {
        this.$store.commit('setNav', 7)
        document.title = '检测标准' + this.$suffix
        this.getStandardList()
    },
    methods: {
        handleCurrentChange(val) {
            this.pageIndex = val
            this.getStandardList()
        },
        /**
         * 获取检测标准
         */
        getStandardList() {
            this.$post('/V1/TestStandard/GetTestStandards',
                {
                    "pageSize": this.pageSize,
                    "pageIndex": this.pageIndex,
                })
                .then((res) => {
                    // console.log('Standard', res)
                    if (res.success) {
                        this.standard = res.response.data
                        this.totalCount = res.response.totalCount
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 下载PDF按钮
         * @param url
         */
        fileLinkToStreamDownload(url, name) {
            let reg = /\.pdf$/;
            if (!reg.test(url)) {
                this.$message.error('传入参数不合法,不是标准的文件链接')
            } else {
                let xhr = new XMLHttpRequest()
                xhr.open('get', url, true)
                xhr.setRequestHeader('Content-Type', `application/pdf`)
                xhr.responseType = 'blob'

                let that = this
                xhr.onload = function () {
                    if (this.status == 200) {//接受二进制文件流
                        let blob = this.response
                        that.downloadExportFile(blob, name)
                    }
                }
                xhr.send()
            }
        },

        downloadExportFile(blob, tagFileName) {
            let downloadElement = document.createElement('a')
            let href = blob
            if (typeof blob == 'string') {
                downloadElement.target = '_blank'
            } else {
                href = window.URL.createObjectURL(blob)//创建下载的链接
            }
            downloadElement.href = href
            downloadElement.download = tagFileName//下载后文件名
            document.body.appendChild(downloadElement)
            downloadElement.click() //点击下载
            document.body.removeChild(downloadElement)//下载完成移除元素
            if (typeof blob != 'string') {
                window.URL.revokeObjectURL(href)//释放掉blob对象
            }
        },
    }
}
</script>

<style scoped lang="less">

.pageBox {
    width: 100%;
    background-color: #f9f9f9;

    .pageFrame {
        padding: 20px 0px;
        width: 1210px;
        margin: 0 auto;

        .haveData {

            .newsList {
                display: flex;
                flex-direction: column;
                min-height: 400px;
                width: 860px;
                max-width: 860px;
                padding: 25px 50px;
                overflow: hidden;
                background-color: white;
                box-shadow: 0px 0px 8px 0px #eaeaea;

                .item_news:nth-child(1) {
                    margin-top: 0;
                }

                .item_news {
                    display: flex;
                    flex-direction: row;
                    margin-top: 30px;
                    padding-bottom: 10px;
                    border-bottom: 1px dashed #ccc;

                    .imgBox {
                        width: 200px;
                        min-width: 200px;
                        height: 100px;
                        overflow: hidden;
                        margin-right: 10px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .newsInfo {
                        display: flex;
                        flex-direction: column;
                        width: 650px;

                        .title {
                            font-size: 18px;
                            color: #333;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            margin-bottom: 3px;
                        }

                        .info {
                            color: #999;
                            font-size: 14px;
                            margin-bottom: 10px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                        }

                        .timeRow {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            font-size: 14px;
                            color: #999;

                            .time {
                                margin-right: 50px;
                            }

                            .scan {

                            }
                        }
                    }
                }
            }


            .pagination {
                margin-top: 30px;
            }
        }

        .noData {
            margin: auto auto;
            color: red;
        }

        ::v-deep .el-tabs--left {
            padding: 40px 0px;
        }

        ::v-deep .el-tabs--left .el-tabs__header {
            background-color: white;
            padding: 40px 0px;
            box-shadow: 0px 0px 8px 0px #eaeaea;
            margin-right: 30px;
        }

        ::v-deep .el-tabs--left .el-tabs__content img {
            max-width: 920px;
        }

        ::v-deep .el-tabs--left .el-tabs__content table {
            max-width: 920px;
        }

        ::v-deep .el-tabs--left .el-tabs__item {
            font-size: 18px;
            width: 220px;
            text-align: center;
        }

        ::v-deep .el-tabs--card {
            background-color: white;
            box-shadow: 0px 0px 4px 0px #E4E7ED;
        }

        ::v-deep .el-tabs--card .el-tabs__header {
            background-color: #F5F7FA;
            padding: 0px;
            box-shadow: 0px 0px 0px 0px transparent;
            margin: 0px;
        }

        ::v-deep .el-tabs--card .el-tabs__content {
            min-height: 400px;
            background-color: transparent;
            width: 880px;
            max-width: 880px;
            padding: 20px 40px;
            overflow: hidden;
            box-shadow: 0px 0px 0px 0px transparent;
            border: 1px solid #E4E7ED;
            border-top: none;
            margin: 0 !important;
        }

        ::v-deep .el-tabs--card .is-active {
            background-color: white;
        }

        ::v-deep .el-tabs--card .el-tabs__item {
            width: 100px;
            padding: 0 !important;
            text-align: center;
            font-size: 15px;
        }


        .item_scan {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            margin-top: 10px;

            .name {
                max-width: 750px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 16px;
                color: #333;
            }

            .scan {
                width: 100px;
                height: 38px;
                background: #1f2d5c;
                color: #fff;
                font-size: 14px;
                border-radius: 4px;
                text-align: center;
                line-height: 38px;
                cursor: pointer;
            }

            .scan:hover {
                box-shadow: 0px 0px 2px 0px #1f2d5c;
            }
        }

        .pagination {
            width: 1210px;
            margin: 0 auto;
        }
    }
}
</style>
